import { Component, Prop, h, Event, EventEmitter, Element, Host } from '@stencil/core';
@Component({
  tag: 'pn-profile-modal-customernumber',
  styleUrl: 'pn-profile-modal-customernumber.scss',
})
export class PnProfileModalCustomernumber {
  @Element() hostElement: Element;

  @Prop({ reflect: true }) url: string = null;
  @Prop({ reflect: true }) customernumber: string = null;
  @Prop({ reflect: true }) selected: boolean = false;

  @Event() urlSelected: EventEmitter;

  onCustomerNumberClick() {
    this.selected = true;
    this.urlSelected.emit(this.url);
  }
  render() {
    return (
      <Host>
        <button class="pn-profile-modal-customernumber-button" onClick={this.onCustomerNumberClick.bind(this)}>
          <slot />
        </button>
      </Host>
    );
  }
}
